import React, { Fragment, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { Redirect, withRouter } from "react-router";
import Login from "./containers/Login";
import Drawer from "./components/Drawer";
import CreateCheckup from "./containers/CreateCheckup";
import CreateUsers from "./containers/CreateUsers";
import ViewUsers from "./containers/ViewUsers";
import LastCheckups from "./containers/LastCheckups";
import Contact from "./containers/Contact";
import EditCheckup from "./containers/EditCheckup";
import ViewCheckups from "./containers/ViewCheckups";
import { withAuthenticator } from "aws-amplify-react";
import { connect } from "react-redux";
import { getUser } from "./store/actions/usersActions";
import { getListOfParks } from "./store/actions/parksActions";
import { Auth } from "aws-amplify";
import { logout } from "./store/actions/auth";
import { toast } from "react-toastify";
import Basket from "./containers/Basket";
import PastOrders from "./containers/PastOrders";

function App({
  history,
  parkID,
  fetchedParks,
  getListOfParks,
  getUser,
  rights,
  logout,
}) {
  useEffect(() => {
    if (!parkID) getUser();

    if (!fetchedParks.length) getListOfParks();
  }, []);

  useEffect(() => {
    if (rights) {
      if (rights.toLowerCase() !== localStorage.getItem("rights").toLowerCase())
        Auth.signOut()
          .then(() => {
            logout();
            localStorage.clear();
          })
          .catch((err) => toast.error(`Error in logging out ${err.message}`));
    }
  }, [rights]);

  return (
    <Fragment>
      {!(history.location.pathname === "/") ? <Drawer /> : ""}
      <Switch>
        <Redirect exact from="/" to="/last-checkups" />
        <Route path="/create-checkups" component={CreateCheckup} />
        <Route path="/edit-checkup" component={EditCheckup} />
        <Route path="/view-checkups" component={ViewCheckups} />
        <Route path="/view-checkups/:date" component={ViewCheckups} />
        <Route path="/last-checkups" component={LastCheckups} />
        <Route path="/create-user" component={CreateUsers} />
        <Route path="/view-users" component={ViewUsers} />
        <Route path="/contact" component={Contact} />
        <Route path="/basket" component={Basket} />
        <Route path="/past-orders" component={PastOrders} />
      </Switch>
    </Fragment>
  );
}

function mapStateToProps(state) {
  return {
    parkID: state?.users?.getUser?.user?.park_id,
    rights: state?.users?.getUser?.user?.rights,
    loginParkID: state?.auth?.parkID,
    fetchedParks: state?.parks?.parks,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getUser: () => dispatch(getUser()),
    getListOfParks: () => dispatch(getListOfParks()),
    logout: () => dispatch(logout()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthenticator(withRouter(App), false, [<Login />]));
